class ArticleInstructions extends HTMLElement {
  constructor() {
    super();
    this.state = {
      'active-step-button': null,
      'active-progress-element': null,
      'last-scroll-position': 0,
      'scroll-direction': 'down',
      'scroll-accumulator': 0,
      'is-section-visible': false
    }

    this.elements = {
      'section': this,
      'steps-buttons': this.querySelectorAll('[data-step-button]'),
      'steps-progress': this.querySelectorAll('[data-step-progress]'),
      'header-section': document.querySelector('.shopify-section-group-header-group')
    }

    this.modificators = {
      'active-step': 'active-step'
    }
  }

  init() {
    this.initListeners();
    this.initSectionObserver();
    this.updateInitialState();
  }

  initListeners() {
    window.addEventListener('scroll', () => {
      this.detectScrollDirection();
      this.updateAllProgressBars();
    })
  }

  updateAllProgressBars() {
    const progressBars = this.elements['steps-progress'];
    const stepButtons = this.elements['steps-buttons'];
    if (!progressBars.length) return;

    const scrollPercent = this.state['scroll-accumulator'];
    const totalSteps = progressBars.length;
    const segmentSize = 100 / totalSteps;
    
    const currentIndex = Math.floor(scrollPercent / segmentSize);
    
    progressBars.forEach((bar, index) => {
      if (index < currentIndex) {
        bar.style.height = '100%';
        this.toggleTargetClass(stepButtons[index], this.modificators['active-step'], true);
      } else if (index === currentIndex) {
        const sectionProgress = (scrollPercent - (index * segmentSize)) * (100 / segmentSize);
        bar.style.height = `${Math.min(sectionProgress, 100)}%`;
        
        const activationPoint = index === 0 ? segmentSize / 2 : (index * segmentSize) - (segmentSize / 2);
        this.toggleTargetClass(
          stepButtons[index], 
          this.modificators['active-step'], 
          scrollPercent >= activationPoint
        );
      } else {
        bar.style.height = '0%';
        this.toggleTargetClass(stepButtons[index], this.modificators['active-step'], false);
      }
    });
  }

  detectScrollDirection() {
    if (!this.state['is-section-visible']) return;
    
    const currentScroll = window.scrollY;
    const sectionRect = this.elements['section'].getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    
    if (currentScroll > this.state['last-scroll-position']) {
      this.state['scroll-direction'] = 'down';
    } else {
      this.state['scroll-direction'] = 'up';
    }

    const totalScrollDistance = sectionRect.height + viewportHeight;
    const currentProgress = viewportHeight - sectionRect.top;
    const scrollPercentage = Math.min(Math.max(
      (currentProgress / totalScrollDistance) * 100,
      0
    ), 100);

    this.state['scroll-accumulator'] = scrollPercentage;
    this.state['last-scroll-position'] = currentScroll;
  }

  initSectionObserver() {
    const callback = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.state['is-section-visible'] = true;
        } else {
          this.state['is-section-visible'] = false;
        }
      });
    };

    const headerHeight = this.elements['header-section'].offsetHeight;

    const observer = new IntersectionObserver(callback, {
      rootMargin: `-${headerHeight}px 0px 0px 0px`
    });

    observer.observe(this);
  }

  connectedCallback() {
    this.init();
  }

  toggleTargetClass(target, modificator, flag) {
    target && target.classList.toggle(modificator, flag)
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.detectScrollDirection);
  }

  updateInitialState() {
    const sectionRect = this.elements['section'].getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    
    if (sectionRect.top < viewportHeight) {
      this.state['is-section-visible'] = true;
      
      const totalScrollDistance = sectionRect.height + viewportHeight;
      const currentProgress = viewportHeight - sectionRect.top;
      const scrollPercentage = Math.min(Math.max(
        (currentProgress / totalScrollDistance) * 100,
        0
      ), 100);

      this.state['scroll-accumulator'] = scrollPercentage;
      this.state['last-scroll-position'] = window.scrollY;
      
      this.updateAllProgressBars();
    }
  }
}

if (customElements.get('article-instructions') === undefined) {
  customElements.define('article-instructions', ArticleInstructions);
}